import { render, staticRenderFns } from "./TypeformQuestionHolder.vue?vue&type=template&id=25de3865&scoped=true&"
import script from "./TypeformQuestionHolder.vue?vue&type=script&lang=js&"
export * from "./TypeformQuestionHolder.vue?vue&type=script&lang=js&"
import style0 from "./TypeformQuestionHolder.vue?vue&type=style&index=0&id=25de3865&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25de3865",
  null
  
)

export default component.exports